<template>
    <q-dialog v-model="isOpen">
        <q-card style="width: 320px">
            <div class="q-pa-md">
                <div class="title">
                    <span v-if="type === 'add'">Add new class</span>
                    <span v-else>Edit class</span>
                </div>
                <q-form @submit.p.prevent="onSubmit">
                    <div class="mb-5">
                        <q-select v-model="selectedGroup"
                                  name="group_id"
                                  :options="groups"
                                  :option-label="group => group.name"
                                  :option-value="group => group"
                                  autofocus
                                  label="Group *"/>
                    </div>
                    <div class="mb-5">
                        <q-input v-model="name"
                                 name="name"
                                 type="text"
                                 lazy-rules
                                 :rules="[val => (val !== null && val !== '') || 'Please enter a name']"
                                 label="Name *"/>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div>
                                <q-btn type="button" color="red" label="CLOSE" @click="close" :disable="isLoading"/>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="text-right">
                                <q-btn type="submit" color="primary" label="SAVE" :disable="isLoading"/>
                            </div>
                        </div>
                    </div>
                </q-form>
            </div>
        </q-card>
    </q-dialog>
</template>

<script>
import axios from "@/axios";

export default {
    name: "ClassFormModal",
    props: {
        open: Boolean,
        type: 'add' | 'edit',
        dataSelectedCompany: Object | null,
        dataGroups: Array,
        dataSelectedGroup: Object | null,
        dataId: String,
        dataName: {
            type: String,
            default: '',
            required: false
        },
        callback: Function,
    },
    data: () => ({
        id: null,
        name: '',
        isLoading: false,
    }),
    computed: {
        isOpen: {
            get() {
                return this.open;
            },
            set(value) {
                this.$emit("update:open", value);
            },
        },
        selectedCompany: {
            get() {
                return this.dataSelectedCompany;
            },
            set(value) {
                this.$emit("update:dataSelectedCompany", value);
            },
        },
        groups: {
            get() {
                return this.dataGroups;
            },
            set(value) {
                this.$emit("update:dataGroups", value);
            },
        },
        selectedGroup: {
            get() {
                return this.dataSelectedGroup;
            },
            set(value) {
                this.$emit("update:dataSelectedGroup", value);
            },
        },
    },
    methods: {
        close() {
            this.name = '';
            this.isOpen = false;
        },
        async onSubmit() {
            this.isLoading = true;
            try {
                if (this.type === 'add') {
                    await axios.put(`/company-vehicle-classes`, {
                        company_id: this.selectedCompany.id,
                        group_id: this.selectedGroup.id,
                        name: this.name,
                    });
                } else if (this.type === 'edit') {
                    await axios.patch(`/company-vehicle-class/${this.id}`, {
                        company_id: this.selectedCompany.id,
                        group_id: this.selectedGroup.id,
                        name: this.name,
                    });
                }
                this.callback();
                this.close();
                this.$q.notify({
                    message: 'Successfully saved',
                    timeout: 250,
                    position: 'top-right',
                    progress: true,
                    type: 'positive'
                });
            } catch (e) {
                this.$q.notify({
                    message: e.response.data.message,
                    timeout: 250,
                    position: 'top-right',
                    progress: true,
                    type: 'negative'
                });
            } finally {
                this.isLoading = false;
            }
        }
    },
    watch: {
        open(value) {
            if (value) {
                this.id = this.dataId;
                this.name = this.dataName;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.2rem;
  font-weight: 500;
}
</style>
